import { Navigate } from 'react-router';

const PublicRoute = ({ isLogin, children }) => {
  return isLogin ? <Navigate to='/hero' /> : children;
};
export default PublicRoute;
